import { render, staticRenderFns } from "./UpdateDocuments.vue?vue&type=template&id=40e3d5a7&scoped=true&"
import script from "./UpdateDocuments.vue?vue&type=script&lang=js&"
export * from "./UpdateDocuments.vue?vue&type=script&lang=js&"
import style0 from "./UpdateDocuments.vue?vue&type=style&index=0&id=40e3d5a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e3d5a7",
  null
  
)

export default component.exports